// Module
var code = "<h3 id=\"глоссарий\">Глоссарий</h3> <p><a href=\"index.md\">Вернуться к содержанию</a></p> ";
// Exports
export default code;